<div class="row">
  <div [ngClass]="utente.isUtenteAdmin ? 'col-6 my-4' : 'col-12 my-4'">
    <h1>{{ente.ragioneSociale}}</h1>
  </div>
  @if (utente.isUtenteAdmin) {
    <div class="col-6 d-flex justify-content-end my-4">
      <it-back-button></it-back-button>
    </div>
  }
  <div class="col-12 col-lg-4">
    <div class="card-wrapper">
      <it-card space="true" borderBottom="true" background="true">
        <h3 class="card-title h5">Anagrafica Ente</h3>
        <p class="card-text">Visualizza e gestisci le informazioni dell'ente.</p>
        <a onclick="return false" href="/" class="read-more" (click)="goToAnagraficaEnte()">
          <span class="text">Vai</span>
          <it-icon name="arrow-right"></it-icon>
        </a>
      </it-card>
    </div>
  </div>
  <div class="col-12 col-lg-4">
    <div class="card-wrapper">
      <it-card space="true" borderBottom="true" background="true">
        <h3 class="card-title h5">Gestione Utenti Master</h3>
        <p class="card-text">Visualizza e gestisci gli utenti master dell'ente.</p>
        <a onclick="return false" href="/" class="read-more" (click)="goToUtentiMaster()">
          <span class="text">Vai</span>
          <it-icon name="arrow-right"></it-icon>
        </a>
      </it-card>
    </div>
  </div>
  <div class="col-12 col-lg-4">
    <div class="card-wrapper">
      <it-card space="true" borderBottom="true" background="true">
        <h3 class="card-title h5">Gestione Utenti Ruoli Applicativi</h3>
        <p class="card-text">Visualizza e gestisci gli utenti ruoli applicativi dell'ente.</p>
        <a onclick="return false" href="/" class="read-more" (click)="goToUtentiApplicativi()">
          <span class="text">Vai</span>
          <it-icon name="arrow-right"></it-icon>
        </a>
      </it-card>
    </div>
  </div>
</div>
